import styled, { css } from 'styled-components'
import { Box } from '@branch-messenger/willow-ui'
import { mobileStyles, tabletStyles } from '@styles/utils'

export const StyledAppLayout = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
})`
  position: relative;
  overflow: hidden;
  height: 100svh;
`

export const StyledAppBodyContainer = styled(Box).attrs({
  $flex: 1,
  $px: 4,
  $fullWidth: true,
})`
  overflow: hidden;
  ${mobileStyles(css`
    padding: 0;
  `)}
`

export const StyledAppBody = styled(Box).attrs({
  $justify: 'center',
  $display: 'flex',
  $fullWidth: true,
  $py: 2,
})`
  height: 100%;

  ${mobileStyles(css`
    justify-content: initial;
    border-radius: 0;
    padding: 0;
  `)}
`

export const StyledAppHeaderContainer = styled(Box).attrs({
  $display: 'flex',
  $fullWidth: true,
  $gap: 4,
  $justify: 'space-between',
  $p: 4,
  $pb: 6,
})`
  ${tabletStyles(css`
    justify-content: center;
  `)}
  ${mobileStyles(css`
    display: none;
  `)}
`

export const StyledHeaderAppStoreContainer = styled(Box).attrs({
  $display: 'flex',
  $gap: 4,
})`
  ${tabletStyles(css`
    display: none;
  `)}
`

export const StyledFooterAppStoreContainer = styled(Box).attrs({
  $display: 'none',
  $gap: 4,
  $mb: 4,
  $justify: 'center',
})`
  ${tabletStyles(css`
    display: flex;
  `)}
`

export const StyledAppFooterContainer = styled(Box).attrs({
  $display: 'flex',
  $justify: 'center',
  $fullWidth: true,
  $p: 4,
})`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  z-index: 1;

  ${mobileStyles(css`
    display: none;
  `)}
`

export const StyledAppFooterContent = styled(Box)`
  max-width: 896px;
  text-align: center;
`
